<template>
		<div style="text-align:justify">
			<div class="mb-3">
					<br>
          <h4>{{ $t('terms_conditions.subtitle') }}</h4>
              {{ $t('terms_conditions.paragraphs.p_1') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_2') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_3') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_4') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_5') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_6') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_7') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_8') }}<br> <br>
              {{ $t('terms_conditions.paragraphs.p_9') }}<br> <br>

          <h5>{{ $t('terms_conditions.contract') }}</h5>
              <br> {{ $t('terms_conditions.contact_paragraphs.p_1') }}
              <br> <br> {{ $t('terms_conditions.contact_paragraphs.p_2') }}
              <br> <br> {{ $t('terms_conditions.contact_paragraphs.p_3') }}
              <br> <br> {{ $t('terms_conditions.contact_paragraphs.p_4') }}
              <br> <br> {{ $t('terms_conditions.contact_paragraphs.p_5') }}
              <br> <br> {{ $t('terms_conditions.contact_paragraphs.p_6') }} <br> <br>

          <h5>{{ $t('terms_conditions.part_contract.part_1.title') }}</h5>
              <b>{{ $t('terms_conditions.part_contract.part_1.paragraphs.t_1.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_1.paragraphs.t_1.text') }} <br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_1.paragraphs.t_2.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_1.paragraphs.t_2.text') }} <br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_1.paragraphs.t_3.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_1.paragraphs.t_3.text')}} <br> <br>

          <h6>{{ $t('terms_conditions.part_contract.part_1.apart.a_1.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_1.apart.a_1.paragraphs.p_1') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_1.apart.a_1.paragraphs.p_2') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_1.apart.a_1.paragraphs.p_3') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_1.apart.a_1.paragraphs.p_4') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_1.apart.a_1.paragraphs.p_5') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_1.apart.a_1.paragraphs.p_6') }} <br> <br>

          <h6>{{ $t('terms_conditions.part_contract.part_1.apart.a_2.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_1.apart.a_2.paragraphs.p_1') }} <br> <br>

          <h5>{{ $t('terms_conditions.part_contract.part_2.title') }}</h5>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_1') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_2') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_3') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_4') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_5') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_6') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_7') }} <br> <br>
              {{ $t('terms_conditions.part_contract.part_2.paragraphs.p_8') }} <br> <br>

          <h6>{{ $t('terms_conditions.part_contract.part_2.apart.a_1.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_2.apart.a_1.paragraphs') }} <br> <br>
          <h6>{{ $t('terms_conditions.part_contract.part_2.apart.a_2.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_2.apart.a_2.paragraphs') }} <br> <br>
          <h6>{{ $t('terms_conditions.part_contract.part_2.apart.a_3.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_2.apart.a_3.paragraphs') }}
              <a href="https://viajero.vallartaplus.mx" style="color:#3E8BC4 !important">
              {{ $t('terms_conditions.part_contract.part_2.apart.a_3.link') }}
              </a> <br> <br>
          <h6>{{ $t('terms_conditions.part_contract.part_2.apart.a_4.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_2.apart.a_4.paragraphs') }}<br> <br>
          <h6>{{ $t('terms_conditions.part_contract.part_2.apart.a_5.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_2.apart.a_5.paragraphs') }} <br><br>
              {{ $t('terms_conditions.part_contract.part_2.apart.a_6.paragraphs') }} <br><br>
              <ul>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_1') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_2') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_3') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_4') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_5') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_6') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_7') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_8') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_9') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_10') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_11') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_12') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_13') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_14') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_15') }}</li>
              </ul> 

          <h6>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.title') }}</h6> <br>
              <ul>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_1') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_2') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_4') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_5') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_6') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_7') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_8') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_9') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_10') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_11') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_12') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_13') }}</li>
                  <li>{{ $t('terms_conditions.part_contract.part_2.apart.a_6.list.li_14') }}</li>
              </ul> 

          <h6>{{ $t('terms_conditions.part_contract.part_2.apart.a_7.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_2.apart.a_7.paragraphs') }}<br> <br>
              
          <h6>{{ $t('terms_conditions.part_contract.section_1.title') }}</h6>
              {{ $t('terms_conditions.part_contract.section_1.paragraphs') }}<br> <br>

          <h5>{{ $t('terms_conditions.part_contract.part_3.title') }}</h5>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_1.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_1.text') }}<br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_2.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_2.text') }}<br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_3.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_3.text') }}<br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_4.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_4.text') }} 
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_4.warning') }}</b><br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_5.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_5.text') }}<br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_6.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_6.text') }}<br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_7.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_7.text') }}<br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_8.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_8.text') }}<br> <br>
              <b>{{ $t('terms_conditions.part_contract.part_3.paragraphs.p_9.title') }}</b>
              {{ $t('terms_conditions.part_contract.part_3.paragraphs.p_9.text') }}<br> <br>

          <h6>{{ $t('terms_conditions.part_contract.part_3.apart.a_1.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_3.apart.a_1.paragraphs') }} <br><br>
          <h6>{{ $t('terms_conditions.part_contract.part_3.apart.a_2.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_3.apart.a_2.paragraphs') }} <br><br>
          <h6>{{ $t('terms_conditions.part_contract.part_3.apart.a_3.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_3.apart.a_3.paragraphs') }} <br><br>
          <h6>{{ $t('terms_conditions.part_contract.part_3.apart.a_4.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_3.apart.a_4.paragraphs') }} <br><br>
          <h6>{{ $t('terms_conditions.part_contract.part_3.apart.a_5.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_3.apart.a_5.paragraphs') }} <br><br>
          <h6>{{ $t('terms_conditions.part_contract.part_3.apart.a_6.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_3.apart.a_6.paragraphs') }} <br> <br>

          <h6>{{ $t('terms_conditions.part_contract.part_4.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_4.paragraphs') }}<br> <br>

          <h6>{{ $t('terms_conditions.part_contract.part_5.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_5.paragraphs') }} <br> <br>
          <h6>{{ $t('terms_conditions.part_contract.part_5.apart.a_1.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_5.apart.a_1.paragraphs') }}<br> <br>

          <h6>{{ $t('terms_conditions.part_contract.part_6.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_6.paragraphs') }} <br> <br>
          <h6>{{ $t('terms_conditions.part_contract.part_6.apart.a_1.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_6.apart.a_1.paragraphs') }} <br> <br>
          <h6>{{ $t('terms_conditions.part_contract.part_6.apart.a_2.title') }}</h6>
              {{ $t('terms_conditions.part_contract.part_6.apart.a_2.paragraphs') }} <br> <br>
          
          <h5>{{ $t('terms_conditions.part_contract.part_7.title') }}</h5>
              {{ $t('terms_conditions.part_contract.part_7.apart.a_1.paragraphs') }}
              <a href="https://viajero.vallartaplus.mx" style="color:#3E8BC4 !important">
              {{ $t('terms_conditions.part_contract.part_7.apart.a_1.link') }}
              </a> <br> <br>
              {{ $t('terms_conditions.part_contract.part_8.t_2') }}<br> <br>
			</div>
		</div>
</template>

<script>
import BCard from "@/components/BCard/Index";

export default {
  name: "term-condition-contact",
  components: {
    BCard: BCard,
  },
  data() {
    return {};
  },
  destroyed() {},
};
</script>